function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 5H2V18.3335H22V5Z",
  fill: "#F0F0F0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22 6.6665H2V8.33303H22V6.6665Z",
  fill: "#D80027"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22 10H2V11.6665H22V10Z",
  fill: "#D80027"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22 13.333H2V14.9995H22V13.333Z",
  fill: "#D80027"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22 16.6665H2V18.333H22V16.6665Z",
  fill: "#D80027"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12 5H2V12.1796H12V5Z",
  fill: "#2E52B2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.89928 7.94141L5.73822 8.43688H5.21729L5.63881 8.74293L5.47775 9.23836L5.89928 8.9323L6.32053 9.23836L6.15951 8.74293L6.58104 8.43688H6.06006L5.89928 7.94141Z",
  fill: "#F0F0F0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.06006 10.2249L5.89928 9.72949L5.73822 10.2249H5.21729L5.63881 10.531L5.47775 11.0264L5.89928 10.7204L6.32053 11.0264L6.15951 10.531L6.58104 10.2249H6.06006Z",
  fill: "#F0F0F0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M3.8585 10.2249L3.69768 9.72949L3.53662 10.2249H3.01569L3.43721 10.531L3.27615 11.0264L3.69768 10.7204L4.11897 11.0264L3.95795 10.531L4.3794 10.2249H3.8585Z",
  fill: "#F0F0F0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M3.69768 7.94141L3.53662 8.43688H3.01569L3.43721 8.74293L3.27615 9.23836L3.69768 8.9323L4.11897 9.23836L3.95795 8.74293L4.3794 8.43688H3.8585L3.69768 7.94141Z",
  fill: "#F0F0F0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M5.89928 6.15332L5.73822 6.64883H5.21729L5.63881 6.95492L5.47775 7.45035L5.89928 7.14425L6.32053 7.45035L6.15951 6.95492L6.58104 6.64883H6.06006L5.89928 6.15332Z",
  fill: "#F0F0F0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M3.69768 6.15332L3.53662 6.64883H3.01569L3.43721 6.95492L3.27615 7.45035L3.69768 7.14425L4.11897 7.45035L3.95795 6.95492L4.3794 6.64883H3.8585L3.69768 6.15332Z",
  fill: "#F0F0F0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M8.10078 7.94141L7.93976 8.43688H7.41882L7.84031 8.74293L7.67933 9.23836L8.10078 8.9323L8.5221 9.23836L8.36105 8.74293L8.78257 8.43688H8.26164L8.10078 7.94141Z",
  fill: "#F0F0F0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M8.26164 10.2249L8.10078 9.72949L7.93976 10.2249H7.41882L7.84031 10.531L7.67933 11.0264L8.10078 10.7204L8.5221 11.0264L8.36105 10.531L8.78257 10.2249H8.26164Z",
  fill: "#F0F0F0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4635 10.2249L10.3027 9.72949L10.1416 10.2249H9.62073L10.0422 10.531L9.88116 11.0264L10.3027 10.7204L10.724 11.0264L10.5629 10.531L10.9844 10.2249H10.4635Z",
  fill: "#F0F0F0"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3027 7.94141L10.1416 8.43688H9.62073L10.0422 8.74293L9.88116 9.23836L10.3027 8.9323L10.724 9.23836L10.5629 8.74293L10.9844 8.43688H10.4635L10.3027 7.94141Z",
  fill: "#F0F0F0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M8.10078 6.15332L7.93976 6.64883H7.41882L7.84031 6.95492L7.67933 7.45035L8.10078 7.14425L8.5221 7.45035L8.36105 6.95492L8.78257 6.64883H8.26164L8.10078 6.15332Z",
  fill: "#F0F0F0"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3027 6.15332L10.1416 6.64883H9.62073L10.0422 6.95492L9.88116 7.45035L10.3027 7.14425L10.724 7.45035L10.5629 6.95492L10.9844 6.64883H10.4635L10.3027 6.15332Z",
  fill: "#F0F0F0"
});

function SvgFlagUsa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUsa);
export default __webpack_public_path__ + "static/media/flag-usa.6bc311eb.svg";
export { ForwardRef as ReactComponent };